/**
 * Styles.
 */
import './style.scss';

import React, { useEffect } from 'react';
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col, Spinner } from 'reactstrap';
import NavigationTopRight from '../../components/navigation-top-right';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { updatePaginatedData } from '../../utils';
import { GET_MEMBERSHIP_DETAIL } from '../../gqls';
import { paymentLinkDetails } from '../../actions/payment-links';

const MembershipDetail = () => {
  const currentUser = useSelector(state => state.currentUser);
  const um = useSelector(state => state.updatePaymentLinks);
  const dispatch = useDispatch();
  const { id } = useParams();

  const { loading, error, data, fetchMore } = useQuery(GET_MEMBERSHIP_DETAIL, {
    variables: {
      search: {
        id: [{ operator: 'eq', value: id }]
      }
    }
  });

  const membership = _.get(data, 'getPaymentLinkFilteredList[0]');

  useEffect(() => {
    if (membership) {
      dispatch(paymentLinkDetails(membership));
    }
  }, [membership, dispatch]);

  const updateData = () => {
    fetchMore({
      variables: {
        search: {
          id: [{ operator: 'eq', value: id }]
        }
      },
      updateQuery: (previousResult, { fetchMoreResult }) =>
        updatePaginatedData('getPaymentLinkFilteredList[0]', previousResult, fetchMoreResult),
      notifyOnNetworkStatusChange: true
    });
  };

  useEffect(() => {
    updateData();
  }, [um]);

  if (error) return `Error! ${error.message}`;

  if (loading) {
    return <Spinner></Spinner>;
  }

  if (data && data.getPaymentLinkFilteredList[0] && !membership) {
    window.location.href = process.env.REACT_APP_BASE_URL;
  }

  return (
    <PageWrap>
      <PageTitle
        className="d-none d-sm-block"
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' ',
          '/memberships': 'Membership & SaaS'
        }}
      >
        <Row className="mb-0">
          <Col md="6">
            <h1>{membership?.name}</h1>
          </Col>
          <Col md="6" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default MembershipDetail;
